import React from 'react';

import classes from './CreateNewTopicForm.module.css';

import FlexModal from '../../UI/FlexModal/FlexModal';
import IconButton from '../../UI/IconButton/IconButton';
import FormFields from '../FormFields';
import Button from '../../UI/Button/Button';

import { IsObjectEmpty, IsStringEmpty, GetObjectClone } from '../../../utilities/CommonMethods';
import Input from '../../UI/Input/Input';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import Wrapper from '../../../hoc/Wrapper/Wrapper';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import { parseDateForInputField, parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class CreateNewTopicForm extends React.Component {

    state = {
        createNewTopicForm: GetObjectClone(FormFields.createNewTopicForm),
        createNewTopicFormValid: false,
        errorMessage: '',
        showErrorMessage: false,
        showFormErrorMessage: false,
        formErrorMessage: '',
        showToolTip: false
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.createNewTopicForm[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;
        if (!IsObjectEmpty(formElement.validation)) {
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                isValid = (value.length > 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }
        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Start Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Start Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Start date can not be empty';
                }

                // let currentDate = new Date();
                // let selectedDate = new Date(value + ' 00:00');

                // let currentDateString = currentDate.getDate() + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear();
                // let selectedDateString = selectedDate.getDate() + '-' + selectedDate.getMonth() + '-' + selectedDate.getFullYear();

                // if (!IsStringEmpty(selectedDate.getTime()) && IsObjectEmpty(this.props.data)) {
                //     if ((selectedDate.getTime() < currentDate.getTime()) && (selectedDateString !== currentDateString)) {
                //         isValid = false && isValid;
                //         formElement.valid = isValid;
                //         formElement.errorMessage = isValid ? '' : 'Previous dates can not be selected.';
                //     }
                // }
            }
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.createNewTopicForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        let inputValue = event.target.value;

        if (inputIdentifier === 'topicTitle' && updatedFormElement.remainingChar > 0) {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);
            inputValue = event.target.value;
        } else if (inputIdentifier === 'topicTitle' && updatedFormElement.remainingChar <= 0) {
            inputValue = event.target.value.substring(0, updatedFormElement.totalChar)
        } else {
            inputValue = event.target.value;
        }

        updatedFormElement.value = inputValue;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ createNewTopicForm: updatedForm, createNewTopicFormValid: formIsValid });
        }
    }

    onCreateTopicButtonClick = () => {
        const updatedForm = { ...this.state.createNewTopicForm };
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let formErrorMessage = '';

        this.setState({ createNewTopicForm: updatedForm, createNewTopicFormValid: formIsValid, showFormErrorMessage: !IsStringEmpty(formErrorMessage), formErrorMessage: formErrorMessage });
        if (formIsValid) {

            let topicFormData = {
                "name": this.state.createNewTopicForm['topicTitle'].value,
                "schedule_date": this.state.createNewTopicForm['startDate'].value,
                "schedule_time": this.state.createNewTopicForm['startTime'].value,
            };

            console.log('Submit Form Data =>>>', topicFormData)

            if (this.props.forEdit === true) {
                this.props.editTopicDetails(this.props.data.topicId, topicFormData);
            } else {
                this.props.createNewTopic(topicFormData);
                // alert('Create new topic')
            }

        }
    }

    setFormData = () => {
        let updatedForm = { ...this.state.createNewTopicForm };

        let topicData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(topicData)) {

            let topicName = '', startDate = '', startTime = '';

            startDate = !IsStringEmpty(topicData.scheduleDate) ? parseDateForInputField(new Date(topicData.scheduleDate)) : '';
            startTime = !IsStringEmpty(topicData.scheduleTime) ? parseTimeForInputField(topicData.scheduleTime) : '';

            updatedForm['topicTitle'].value = topicName;
            updatedForm['startDate'].value = startDate;
            updatedForm['startTime'].value = startTime;

            this.setState({ createNewTopicForm: updatedForm });

        }
    }

    setScheduleDate = () => {
        let updatedForm = { ...this.state.createNewTopicForm };
        updatedForm['startDate'].value = this.props.selectedDate;
        this.setState({ createNewTopicForm: updatedForm });
    }

    componentDidMount() {
        // this.setFormData();
        if (this.props.forEdit === false && !IsStringEmpty(this.props.selectedDate)) {
            this.setScheduleDate();
        }
    }

    inputFieldTopic = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.createNewTopicForm[key].elementType}
            elementConfig={this.state.createNewTopicForm[key].elementConfig}
            label={this.state.createNewTopicForm[key].label}
            value={this.state.createNewTopicForm[key].value}
            options={this.state.createNewTopicForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.createNewTopicForm[key].touched}
            afterText={this.state.createNewTopicForm[key].remainingChar}
            dropdownOpen={this.state.createNewTopicForm[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.createNewTopicForm[key].validation) ? (!IsObjectEmpty(this.state.createNewTopicForm[key].validation.required) ? this.state.createNewTopicForm[key].validation.required.value : false) : false}
            showError={(!this.state.createNewTopicFormValid && !this.state.createNewTopicForm[key].valid) ? true : false}
            error={this.state.createNewTopicForm[key].errorMessage}
        // disableDates={true}
        // disableDateValue={{ minDate: minDate, maxDate: maxDate }}
        />
    }

    render() {
        return (
            <FlexModal visible={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.CreateTopicFormContainer}>
                    <div className={classes.CloseIcon}>
                        <IconButton
                            styleclass='NoBorder SmallIcon'
                            icon={closeIconBlack}
                            altText='Close Icon'
                            clicked={() => this.props.closePopup('')}
                        />
                    </div>
                    <h3 className={classes.PopupHeading}>
                        {this.props.forEdit === true ? 'Edit Topic' : 'Create New Topic'}
                    </h3>

                    {this.props.showLoader
                        ? <div className={classes.FormLoaderContainer}>
                            <ShowLoader isLoading={this.props.showLoader} transparentBg={true} />
                        </div>
                        : <Wrapper>
                            <div className={classes.FormInput}>
                                {this.inputFieldTopic('topicTitle')}
                            </div>

                            <h4 className={classes.LiveSessionHeading}>LIVE Session</h4>

                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldTopic('startDate')}
                            </div>
                            <div className={[classes.FormInputHalf, classes.AddMarginRight].join(' ')}>
                                {this.inputFieldTopic('startTime')}
                            </div>
                            {
                                this.state.showFormErrorMessage
                                    ? <p className={classes.ErrorText}>{this.state.formErrorMessage}</p> : null
                            }

                            <div className={classes.ButtonContainer}>
                                <Button
                                    styleclass="NonMobileOnly"
                                    label={this.props.forEdit ? "UPDATE TOPIC" : "CREATE TOPIC"}
                                    clicked={this.onCreateTopicButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="16px 20px 20px 0px"
                                />
                                <Button
                                    styleclass="MobileOnly"
                                    label={this.props.forEdit ? "UPDATE TOPIC" : "CREATE TOPIC"}
                                    clicked={this.onCreateTopicButtonClick}
                                    disabled={false}
                                    tooltip={null}
                                    margin="0px"
                                    padding="1em 2em"
                                    fontSize="0.625em"
                                />
                            </div>
                        </Wrapper>
                    }
                </div>
            </FlexModal>
        );
    }
}

export default CreateNewTopicForm;